<div class="plan-config">
    <!-- Hero -->
    <!-- TODO re-enable: hidden per request -->
    <div class="pc-hero" *ngIf="PC_HERO_ENABLED">
        <div class="pc-hero-bg"></div>
        <div class="pc-hero-content">
            <div class="pc-hero-left">
                <span class="pc-hero-icon"><i class="pi pi-sliders-h"></i></span>
                <div>
                    <h3 class="pc-hero-title">Plan Configuration</h3>
                </div>
            </div>
            <div class="pc-hero-right">
                <span class="pc-plan-pill" *ngIf="selectedPlan">{{ selectedPlan }} plan</span>
            </div>
        </div>
    </div>

    <!-- Loading skeleton -->
    <ng-container *ngIf="isLoadingPlans">
        <div class="pc-card">
            <div class="pc-card-head">
                <div class="pc-card-head-left">
                    <p-skeleton shape="circle" size="38px"></p-skeleton>
                    <div class="pc-skel-head-text">
                        <p-skeleton width="9rem" height="1rem" styleClass="mb-2"></p-skeleton>
                        <p-skeleton width="14rem" height="0.75rem"></p-skeleton>
                    </div>
                </div>
                <p-skeleton width="5.5rem" height="1.5rem"></p-skeleton>
            </div>
            <div class="grid">
                <div class="col-12 md:col-6">
                    <p-skeleton height="2.85rem"></p-skeleton>
                </div>
                <div class="col-12 md:col-6">
                    <p-skeleton height="2.85rem"></p-skeleton>
                </div>
            </div>
        </div>
        <div class="pc-card">
            <div class="pc-card-head">
                <div class="pc-card-head-left">
                    <p-skeleton shape="circle" size="38px"></p-skeleton>
                    <div class="pc-skel-head-text">
                        <p-skeleton width="8rem" height="1rem" styleClass="mb-2"></p-skeleton>
                        <p-skeleton width="12rem" height="0.75rem"></p-skeleton>
                    </div>
                </div>
            </div>
            <div class="grid">
                <div class="col-12 sm:col-6 md:col-3" *ngFor="let i of [1,2,3,4]">
                    <p-skeleton height="2.85rem"></p-skeleton>
                </div>
            </div>
        </div>
        <div class="pc-card">
            <div class="pc-card-head">
                <div class="pc-card-head-left">
                    <p-skeleton shape="circle" size="38px"></p-skeleton>
                    <div class="pc-skel-head-text">
                        <p-skeleton width="6rem" height="1rem"></p-skeleton>
                    </div>
                </div>
            </div>
            <div class="pc-feature-grid">
                <p-skeleton height="3.2rem" styleClass="mb-0" *ngFor="let i of [1,2,3,4]"></p-skeleton>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="!isLoadingPlans">

    <!-- Free Online Store Setup Offer (admin) -->
    <!-- TODO re-enable: hidden because it duplicates the "Store Content" card in bizz-customer-personal-info -->
    <div class="pc-card" *ngIf="STORE_OFFER_CARD_ENABLED && showStoreOffer">
        <div class="pc-card-head pc-card-head--clickable" (click)="toggleSection('storeOffer')">
            <div class="pc-card-head-left">
                <span class="pc-card-icon pc-icon-blue"><i class="pi pi-shopping-bag"></i></span>
                <div>
                    <span class="pc-card-title">Free Online Store Setup</span>
                    <span class="pc-card-desc">Merchant opted in for the “we set up your store for free” offer.</span>
                </div>
            </div>
            <div class="pc-card-head-right">
                <p-tag
                    [value]="storeOfferCompleted ? 'Completed' : (storeOfferHasFile ? 'Awaiting Admin' : 'Awaiting Merchant')"
                    [severity]="storeOfferCompleted ? 'success' : (storeOfferHasFile ? 'warning' : 'info')"
                ></p-tag>
                <i class="pi pc-collapse-chevron" [ngClass]="sectionExpanded.storeOffer ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </div>
        </div>

        <ng-container *ngIf="sectionExpanded.storeOffer">
            <!-- Completed -->
            <div class="pc-store-done" *ngIf="storeOfferCompleted">
                <i class="pi pi-check-circle"></i>
                <div>
                    <span class="pc-store-done-title">This offer has been completed by admin.</span>
                    <span class="pc-store-done-sub" *ngIf="storeOffer.completedDate">
                        Completed on {{ storeOffer.completedDate | date : "MMM d, y, h:mm a" }}
                    </span>
                </div>
            </div>

            <!-- Pending merchant upload -->
            <div class="pc-callout" *ngIf="!storeOfferCompleted && !storeOfferHasFile">
                <i class="pi pi-clock"></i>
                <span>Waiting for the merchant to submit their store details. You can mark this complete once a file has been uploaded.</span>
            </div>

            <!-- Ready for admin action -->
            <ng-container *ngIf="!storeOfferCompleted && storeOfferHasFile">
                <div class="pc-store-file">
                    <i class="pi pi-paperclip"></i>
                    <a [href]="storeOffer.fileUrl" target="_blank" rel="noopener">View submitted store details</a>
                </div>
                <div class="pc-store-actions">
                    <button
                        pButton
                        type="button"
                        label="Mark offer as completed"
                        icon="pi pi-check"
                        [loading]="isSavingStoreOffer"
                        [disabled]="!canCompleteStoreOffer || isSavingStoreOffer"
                        (click)="completeStoreOffer()"
                    ></button>
                </div>
                <small class="pc-note">Marking complete stops the merchant's store-setup notification bar and stamps the completion date.</small>
            </ng-container>
        </ng-container>
    </div>

    <!-- Account Status -->
    <div class="pc-card">
        <div class="pc-card-head pc-card-head--clickable" (click)="toggleSection('accountStatus')">
            <div class="pc-card-head-left">
                <span class="pc-card-icon pc-icon-primary"><i class="pi pi-verified"></i></span>
                <div>
                    <span class="pc-card-title">Account Status</span>
                    <span class="pc-card-desc" *ngIf="sectionExpanded.accountStatus">Stripe connection and merchant-reported setup flags.</span>
                    <span class="pc-card-summary" *ngIf="!sectionExpanded.accountStatus">
                        {{ isStripeConnected ? 'Stripe connected' : 'Stripe not connected' }}
                    </span>
                </div>
            </div>
            <i class="pi pc-collapse-chevron" [ngClass]="sectionExpanded.accountStatus ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        </div>

        <div class="pc-account-status" *ngIf="sectionExpanded.accountStatus">
            <div class="pc-status-row">
                <span class="pc-label">Stripe</span>
                <div class="pc-status-row-left">
                    <p-tag
                        [value]="isStripeConnected ? 'Connected' : 'Not connected'"
                        [severity]="isStripeConnected ? 'success' : 'danger'"
                    ></p-tag>
                    <a
                        *ngIf="stripeOnboardingUrl"
                        [href]="stripeOnboardingUrl"
                        target="_blank"
                        rel="noopener"
                        class="pc-status-link"
                    >{{ isStripeConnected ? 'View' : 'Complete onboarding' }} <i class="pi pi-external-link"></i></a>
                </div>
            </div>
            <div class="pc-status-row" *ngIf="cancellationRequested">
                <span class="pc-label">Cancellation</span>
                <p-tag value="Requested" severity="danger"></p-tag>
            </div>
            <div class="pc-status-row" *ngIf="upgradeRequested">
                <span class="pc-label">Upgrade</span>
                <p-tag value="Requested" severity="info"></p-tag>
            </div>
            <!-- TODO re-enable: hidden per request -->
            <ng-container *ngIf="ACCOUNT_STATUS_ONBOARDING_FLAGS_ENABLED">
                <div class="pc-status-row">
                    <span class="pc-label">Physical store</span>
                    <p-tag [value]="hasPhysicalStoreFlag ? 'Yes' : 'No'" [severity]="hasPhysicalStoreFlag ? 'success' : null"></p-tag>
                </div>
                <div class="pc-status-row">
                    <span class="pc-label">Mobile app</span>
                    <p-tag [value]="hasMobileAppFlag ? 'Yes' : 'No'" [severity]="hasMobileAppFlag ? 'success' : null"></p-tag>
                </div>
            </ng-container>
        </div>
    </div>

    <!-- Free Transactions -->
    <div class="pc-card" *ngIf="isTransactionable">
        <div class="pc-card-head pc-card-head--clickable" (click)="toggleSection('freeTransactions')">
            <div class="pc-card-head-left">
                <span class="pc-card-icon pc-icon-violet"><i class="pi pi-ticket"></i></span>
                <div>
                    <span class="pc-card-title">Free Transactions</span>
                    <span class="pc-card-desc" *ngIf="sectionExpanded.freeTransactions">Orders that skip the platform fee.</span>
                    <span class="pc-card-summary" *ngIf="!sectionExpanded.freeTransactions">
                        {{ effective.freeOrdersAllowed ?? 0 }} free orders allowed
                    </span>
                </div>
            </div>
            <i class="pi pc-collapse-chevron" [ngClass]="sectionExpanded.freeTransactions ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        </div>
        <div class="grid" *ngIf="sectionExpanded.freeTransactions">
            <div class="col-12" *ngIf="freeOrdersOverageWarning">
                <div class="pc-callout">
                    <i class="pi pi-exclamation-triangle"></i>
                    <span>
                        Merchant already used {{ ordersUsedSoFar }} of the new {{ effective.freeOrdersAllowed }} allowed —
                        with this reset type, usage never goes back down, so they're locked out of free orders until you raise this limit.
                    </span>
                </div>
            </div>
            <div class="col-12 md:col-6">
                <label class="pc-label">Free orders allowed</label>
                <p-inputNumber
                    [ngModel]="effective.freeOrdersAllowed"
                    (ngModelChange)="setOverride('freeOrdersAllowed', $event)"
                    [min]="0"
                    [max]="100000"
                    [showButtons]="false"
                    [disabled]="effective.resetType === 'None'"
                    styleClass="w-full"
                    [ngClass]="{ 'pc-invalid': effective.freeOrdersAllowed === null }"
                ></p-inputNumber>
                <small class="pc-note" *ngIf="effective.resetType === 'None'">Not applicable — "No free orders" is selected</small>
                <small class="pc-note" *ngIf="effective.resetType !== 'None' && effective.freeOrdersAllowed !== null">orders — then fee applies</small>
                <small class="pc-note pc-note--error" *ngIf="effective.resetType !== 'None' && effective.freeOrdersAllowed === null">Required — enter 0 or more</small>
            </div>
            <div class="col-12 md:col-6">
                <label class="pc-label">Reset type</label>
                <p-dropdown
                    [options]="resetTypeOptions"
                    [ngModel]="effective.resetType"
                    (ngModelChange)="setOverride('resetType', $event)"
                    optionLabel="label"
                    optionValue="value"
                    styleClass="w-full"
                ></p-dropdown>
                <small class="pc-note">How often "orders used so far" resets to 0</small>
                <small class="pc-note" *ngIf="effective.resetType === 'Daily' || effective.resetType === 'Monthly'">
                    Resets on the calendar boundary, not this merchant's billing renewal date.
                </small>
            </div>
            <div class="col-12 md:col-6">
                <label class="pc-label">Orders used so far</label>
                <div class="pc-progress-box">
                    <div class="pc-progress-row">
                        <span class="pc-progress-value">{{ ordersUsedSoFar }} of {{ effective.freeOrdersAllowed }}</span>
                        <span class="pc-progress-label">used</span>
                    </div>
                    <div class="pc-progress-track">
                        <div class="pc-progress-fill"
                            [style.width.%]="freeOrdersUsagePercent">
                        </div>
                    </div>
                </div>
                <small class="pc-note" *ngIf="nextFreeOrdersResetEstimate">
                    Est. next reset: {{ nextFreeOrdersResetEstimate }}
                </small>
                <small class="pc-note" *ngIf="!nextFreeOrdersResetEstimate">
                    This reset type never resets usage automatically.
                </small>
            </div>
        </div>
    </div>

    <!-- Platform Fee -->
    <div class="pc-card pc-card--accent" *ngIf="isTransactionable">
        <div class="pc-card-head pc-card-head--clickable" (click)="toggleSection('platformFee')">
            <div class="pc-card-head-left">
                <span class="pc-card-icon pc-icon-primary"><i class="pi pi-dollar"></i></span>
                <div>
                    <span class="pc-card-title">Platform Fee</span>
                    <span class="pc-card-desc" *ngIf="sectionExpanded.platformFee">Charged per successful order.</span>
                    <span class="pc-card-summary" *ngIf="!sectionExpanded.platformFee">
                        <ng-container [ngSwitch]="effective.chargeType">
                            <ng-container *ngSwitchCase="'fixed'">${{ effective.feeAmount | number:'1.2-2' }} / order</ng-container>
                            <ng-container *ngSwitchCase="'percentage'">{{ effective.feeAmount | number:'1.2-2' }}% of order</ng-container>
                            <ng-container *ngSwitchDefault>No fee</ng-container>
                        </ng-container>
                    </span>
                </div>
            </div>
            <i class="pi pc-collapse-chevron" [ngClass]="sectionExpanded.platformFee ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        </div>

        <ng-container *ngIf="sectionExpanded.platformFee">
        <!-- Live preview -->
        <div class="pc-fee-preview">
            <span class="pc-fee-preview-label">Current fee</span>
            <span class="pc-fee-preview-value" [class.pc-fee-preview-value--none]="effective.chargeType === 'none'">
                <ng-container [ngSwitch]="effective.chargeType">
                    <ng-container *ngSwitchCase="'fixed'">${{ effective.feeAmount | number:'1.2-2' }} <small>/ order</small></ng-container>
                    <ng-container *ngSwitchCase="'percentage'">{{ effective.feeAmount | number:'1.2-2' }}% <small>of order</small></ng-container>
                    <ng-container *ngSwitchDefault>No fee</ng-container>
                </ng-container>
            </span>
        </div>

        <div class="grid">
            <div class="col-12 md:col-7">
                <label class="pc-label">Charge type</label>
                <p-selectButton
                    [options]="chargeTypeOptions"
                    [ngModel]="effective.chargeType"
                    (ngModelChange)="setOverride('chargeType', $event)"
                    optionLabel="label"
                    optionValue="value"
                    styleClass="w-full pc-segmented"
                ></p-selectButton>
            </div>
            <div class="col-12 md:col-5">
                <label class="pc-label">Fee amount</label>
                <p-inputNumber
                    [(ngModel)]="feeAmountDraft"
                    (onBlur)="commitFeeAmount()"
                    [disabled]="effective.chargeType === 'none'"
                    [minFractionDigits]="2"
                    [maxFractionDigits]="2"
                    [min]="0"
                    [max]="effective.chargeType === 'percentage' ? 100 : 100000"
                    [prefix]="effective.chargeType === 'fixed' ? '$' : ''"
                    [suffix]="effective.chargeType === 'percentage' ? '%' : ''"
                    styleClass="w-full"
                    [ngClass]="{ 'pc-invalid': effective.chargeType !== 'none' && !(effective.feeAmount > 0) }"
                ></p-inputNumber>
                <small class="pc-note" *ngIf="effective.chargeType === 'none' || effective.feeAmount > 0">{{ effective.chargeType === 'percentage' ? 'of order value' : 'per order' }}</small>
                <small class="pc-note pc-note--error" *ngIf="effective.chargeType !== 'none' && !(effective.feeAmount > 0)">Enter an amount greater than 0</small>
            </div>
        </div>
        <div class="pc-callout">
            <i class="pi pi-lock"></i>
            <span>Fee is locked to the order at time of payment. Changes here apply to future orders only.</span>
        </div>
        </ng-container>
    </div>

    <!-- Payment Gateway -->
    <div class="pc-card">
        <div class="pc-card-head pc-card-head--clickable" (click)="toggleSection('paymentGateway')">
            <div class="pc-card-head-left">
                <span class="pc-card-icon pc-icon-primary"><i class="pi pi-credit-card"></i></span>
                <div>
                    <span class="pc-card-title">Payment Gateway</span>
                    <span class="pc-card-desc" *ngIf="sectionExpanded.paymentGateway">Current Stripe processing fee for this merchant.</span>
                    <span class="pc-card-summary" *ngIf="!sectionExpanded.paymentGateway">{{ stripePaymentGatewayFee }}</span>
                </div>
            </div>
            <i class="pi pc-collapse-chevron" [ngClass]="sectionExpanded.paymentGateway ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        </div>

        <ng-container *ngIf="sectionExpanded.paymentGateway">
        <div class="pc-fee-preview">
            <span class="pc-fee-preview-label">Stripe fee</span>
            <span class="pc-fee-preview-value">{{ stripePaymentGatewayFee }}</span>
        </div>
        </ng-container>
    </div>

    <!-- Limits & Access -->
    <div class="pc-card">
        <div class="pc-card-head pc-card-head--clickable" (click)="toggleSection('limits')">
            <div class="pc-card-head-left">
                <span class="pc-card-icon pc-icon-blue"><i class="pi pi-key"></i></span>
                <div>
                    <span class="pc-card-title">Limits & Access</span>
                    <span class="pc-card-desc" *ngIf="sectionExpanded.limits">Resource caps for this merchant.</span>
                    <span class="pc-card-summary" *ngIf="!sectionExpanded.limits">{{ limitsSummary }}</span>
                </div>
            </div>
            <i class="pi pc-collapse-chevron" [ngClass]="sectionExpanded.limits ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        </div>
        <div class="pc-callout" *ngIf="sectionExpanded.limits">
            <i class="pi pi-info-circle"></i>
            <span>These caps aren't checked against what the merchant actually has provisioned — confirm their current product/location/register/staff counts before lowering a value, or you may cut off something already in use.</span>
        </div>
        <div class="grid" *ngIf="sectionExpanded.limits">
            <div class="col-12 sm:col-6 md:col-3">
                <div class="pc-stat">
                    <label class="pc-label"><i class="pi pi-box"></i> Allowed products</label>
                    <p-inputNumber
                        [ngModel]="effective.allowedProducts"
                        (ngModelChange)="setOverride('allowedProducts', $event)"
                        [min]="1"
                        [max]="1000000"
                        [placeholder]="effective.allowedProducts === null ? 'Unlimited' : ''"
                        styleClass="w-full"
                    ></p-inputNumber>
                </div>
            </div>
            <div class="col-12 sm:col-6 md:col-3">
                <div class="pc-stat">
                    <label class="pc-label"><i class="pi pi-building"></i> Store locations</label>
                    <p-inputNumber
                        [ngModel]="effective.storeLocations"
                        (ngModelChange)="setOverride('storeLocations', $event)"
                        [min]="1"
                        [max]="10000"
                        [placeholder]="effective.storeLocations === null ? 'Unlimited' : ''"
                        styleClass="w-full"
                    ></p-inputNumber>
                </div>
            </div>
            <div class="col-12 sm:col-6 md:col-3">
                <div class="pc-stat">
                    <label class="pc-label"><i class="pi pi-map-marker"></i> Inventory locations</label>
                    <p-inputNumber
                        [ngModel]="effective.inventoryLocations"
                        (ngModelChange)="setOverride('inventoryLocations', $event)"
                        [min]="1"
                        [max]="10000"
                        [placeholder]="effective.inventoryLocations === null ? 'Unlimited' : ''"
                        styleClass="w-full"
                    ></p-inputNumber>
                </div>
            </div>
            <div class="col-12 sm:col-6 md:col-3">
                <div class="pc-stat">
                    <label class="pc-label"><i class="pi pi-desktop"></i> Registers</label>
                    <p-inputNumber
                        [ngModel]="effective.registers"
                        (ngModelChange)="setOverride('registers', $event)"
                        [min]="1"
                        [max]="10000"
                        [placeholder]="effective.registers === null ? 'Unlimited' : ''"
                        styleClass="w-full"
                    ></p-inputNumber>
                </div>
            </div>
            <div class="col-12 sm:col-6 md:col-3">
                <div class="pc-stat">
                    <label class="pc-label"><i class="pi pi-users"></i> Staff accounts</label>
                    <p-inputNumber
                        [ngModel]="effective.staffAccounts"
                        (ngModelChange)="setOverride('staffAccounts', $event)"
                        [min]="1"
                        [max]="10000"
                        [placeholder]="effective.staffAccounts === null ? 'Unlimited' : ''"
                        styleClass="w-full"
                    ></p-inputNumber>
                </div>
            </div>
        </div>
    </div>

    <!-- Features -->
    <div class="pc-card" *ngIf="featuresEnabled">
        <div class="pc-card-head pc-card-head--clickable" (click)="toggleSection('features')">
            <div class="pc-card-head-left">
                <span class="pc-card-icon pc-icon-green"><i class="pi pi-th-large"></i></span>
                <div>
                    <span class="pc-card-title">Features</span>
                    <span class="pc-card-desc" *ngIf="sectionExpanded.features">Capabilities included with this plan.</span>
                    <span class="pc-card-summary" *ngIf="!sectionExpanded.features">{{ enabledFeatureCount }} of {{ visiblePlanFeatures.length }} enabled</span>
                </div>
            </div>
            <i class="pi pc-collapse-chevron" [ngClass]="sectionExpanded.features ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        </div>
        <ng-container *ngIf="sectionExpanded.features">
        <div class="pc-feature-grid">
            <div class="pc-feature" *ngFor="let feature of visiblePlanFeatures; trackBy: trackByFeatureKey"
                [class.pc-feature--on]="feature.included">
                <span class="pc-feature-label">
                    {{ feature.label }}
                </span>
                <p-inputSwitch
                    [ngModel]="feature.included"
                    (ngModelChange)="setFeatureOverride(feature.key, $event)"
                ></p-inputSwitch>
            </div>
        </div>
        <div class="pc-empty" *ngIf="visiblePlanFeatures.length === 0">
            No features available for this plan.
        </div>
        </ng-container>
    </div>

    <!-- Footer -->
    <div class="pc-footer">
        <div class="pc-footer-actions">
            <button pButton type="button" label="Save" icon="pi pi-check" [loading]="isSavingOverrides" [disabled]="!isFormValid || isSavingOverrides" (click)="saveOverrides()"></button>
        </div>
    </div>

    </ng-container>
</div>
